<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>

<div class="common-padding">

  <!-- <h4 class="headspace">SUCCESSION PLANNING</h4> -->
  <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-4">
    <span class="span-create-edit-hoshin color">SUCCESSION PLANNING</span>
    <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/SuccessionPlanningUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
</div>
  <div class="admin-font-style">
    <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
      <label class="col-md-3 zeroLeftPad">Select Site</label>
      <ng-select placeholder="--Select Site--" class="col-md-8" [items]="siteList" name="siteName" bindLabel="siteName"
        [(ngModel)]="selectedSite" (change)="siteChange($event)" required></ng-select>
    </div>

    <div class="col-md-6 inlineFlex zeroRightPad">
      <span class="divide-width"></span>
      <label class="col-md-3">Select BPG</label>
      <ng-select placeholder="--Select BPG--" class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName"
        bindLabel="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" required></ng-select>
    </div>

    <!-- <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
      <label class="col-md-3 zeroLeftPad">Area of Impact</label>
      <ng-select placeholder="--Select Area of Impact--" class="col-md-8" [items]="areaOfImpactList" name="areaImpact"
        bindLabel="areaImpact" bindValue="areaOfImpactId" (change)="areaOfImpactChange($event)"
        [(ngModel)]="selectedAreaImpact" [multiple]="true" required></ng-select>
    </div>

    <div class="col-md-6 inlineFlex zeroRightPad">
      <span class="divide-width"></span>
      <label class="col-md-3">Skills</label>
      <ng-select placeholder="--Select Skill--" class="col-md-8" [items]="skillList" name="skillName"
        bindLabel="skillName" bindValue="skillId" (change)="skillsChange($event)" [(ngModel)]="selectedSkills"
        [multiple]="true" required></ng-select>
    </div> -->

    <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
      <label class="col-md-3 zeroLeftPad">Leadership Interest </label>
      <ng-select placeholder="--Select Leadership Interest--" class="col-md-8" [items]="leadershipInterestList"
        name="leadershipType" bindLabel="leadershipType" bindValue="leadershipTypeId"
        (change)="leadershipTypeChange($event)" [(ngModel)]="selectedInterest" [multiple]="true" required></ng-select>
    </div>

    <!-- <div class="col-md-6 inlineFlex zeroRightPad">
      <span class="divide-width"></span>
      <label class="col-md-3">Membership Type</label>
      <ng-select placeholder="--Select Membership Type--" class="col-md-8 zeroRightPad" [items]="membershipType"
        name="membershipType" bindLabel="typeName" bindValue="typeId" [(ngModel)]="selectedMembershipType"
        (change)="membershipTypeChange($event)" required></ng-select>
    </div> -->

  </div>

</div>

<div class="top-space text-center col-md-12">
  <button type="button" class="btn btn-danger col-sm-2 col-md-2 style"
    (click)="getMembershipReportList()">GENERATE</button>
  <span class="preview"></span>
  <button type="button" class="btn btn-danger col-sm-2 col-md-2 style" data-toggle="modal" (click)="resetClick()"
    data-target="#myModal">RESET</button>
  <span class="preview"></span>
  <button type="button" class="btn btn-danger col-sm-2 col-md-2 style" [disabled]="membershipReportList.length==0"
    (click)="exportAsCSV()">EXPORT TO CSV</button>
</div>

<!--table-->

<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div class="tabledemo1" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col">Site</th>
          <th scope="col">BPG</th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <!-- <th scope="col">Workday ID</th> -->
          <th scope="col">Email</th>
          <!-- <th scope="col">Area of Impact</th>
          <th scope="col">Skills</th> -->
          <th scope="col">Leadership Interest</th>
          <th scope="col">Virtual Membership</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of membershipReportList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.site}}</td>
          <td>{{data.bpg}}</td>
          <td>{{data.firstName}}</td>
          <td>{{data.lastName}}</td>
          <!-- <td>{{data.workday_id}}</td> -->
          <td>{{data.email}}</td>
          <!-- <td>{{data.area_of_impact}}</td>
          <td>{{data.skills}}</td> -->
          <td>{{data.leadershipInterest}}</td>
          <td>{{data.membershipType}}</td>
        </tr>
      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>

<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>